"use strict";

import AxiosService from "../AxiosService";

const ASSIGNMENTS = "/api/v1/assignments";
const WORKLIST_PLANNER = "/api/v1/addresses/assignments/";
const CLIENT_ENDPOINT = "/api/v1/clients";

export default class AssignmentService {
  constructor() {
    this.service = new AxiosService();
  }

  resolveClients() {
    return this.service.get(CLIENT_ENDPOINT);
  }

  resolveAreas(clientName) {
    return this.service.get(CLIENT_ENDPOINT + `/${clientName}/areas-filtered`);
  }

  resolveAssignments(query) {
    var queryParam = [];

    if (query.pageSize) {
      queryParam.push("size=" + query.pageSize);
    }
    if (query.pageNumber) {
      queryParam.push("page=" + query.pageNumber);
    }

    return this.service.get(ASSIGNMENTS + "?" + queryParam.join("&"));
  }

  resolveAddresses(query) {
    var queryParam = [];

    if (query.pageSize) {
      queryParam.push("size=" + query.pageSize);
    }
    if (query.pageNumber) {
      queryParam.push("page=" + query.pageNumber);
    }

    return this.service.get(
      WORKLIST_PLANNER + query.assignmentId + "?" + queryParam.join("&")
    );
  }
}
